import React from 'react';
import { trimUserName, formatNumberWithCommas } from '../utils';

const TopFiveLeaderboard = ({ userData, rank, currentUserId }) => {
  const { userName, totalRewardsInINR, userId } = userData;
  const formattedUserName = trimUserName(userName);
  const isCurrentUser = currentUserId && userId && currentUserId === userId;

  const containerStyle = {
    backgroundColor: isCurrentUser ? '#614385' : 'transparent',
    color: '#FFFFFF',
    padding: isCurrentUser ? '5px 9px' : '0',
    borderRadius: isCurrentUser ? '8px' : '0',
    margin: isCurrentUser ? '7px -10px 0px -10px' : '0',
    fontWeight: 400,
  };

  return (
    <div className="d-flex justify-content-between top-stackers" style={containerStyle}>
      <div>
        <span
          style={{
            color: '#FFFFFF',
            fontWeight: 500,
            display: 'inline-block',
            width: '30px',
            textAlign: 'left',
          }}
        >
          #{rank}
        </span>
        <span
          className="userName"
          style={{
            color: '#FFFFFF',
            fontWeight: 400,
            marginLeft: '8px',
          }}
        >
          {formattedUserName}
        </span>
      </div>
      <div>
        <span
          className="userSats"
          style={{
            color: '#FFFFFF',
            display: 'inline-block',
            width: '120px',
            textAlign: 'right',
          }}
        >
          ₹{formatNumberWithCommas(Math.round(totalRewardsInINR || 0))}
        </span>
      </div>
    </div>
  );
};

export default TopFiveLeaderboard;
